import { FC, PropsWithChildren } from 'react';
import '../../styles/IffPanel.css';
import { IressPanel } from '@iress-oss/ids-components';

export const IffPanel: FC<PropsWithChildren<{ testId?: string }>> = ({ children, testId }) => (
    <IressPanel className="iff-panel" padding={{ t: 'md', x: 'lg' }} data-testid={testId ?? null}>
        {children}
    </IressPanel>
);
